import { render } from "./SayYes.vue?vue&type=template&id=785b0766"
import script from "./SayYes.vue?vue&type=script&lang=js"
export * from "./SayYes.vue?vue&type=script&lang=js"

import "./SayYes.vue?vue&type=style&index=0&id=785b0766&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__